@if (isModalMode) {
	<app-modal-wrap
		(onClose)="onClose.emit()"
		[modalWrapperClass]="
			report_name === 'debts_report2' ? 'modal-1200' : 'modal-full-width'
		"
	>
		<ng-container
			header
			*ngTemplateOutlet="head"
		/>
		<ng-container *ngTemplateOutlet="body" />
	</app-modal-wrap>
} @else {
	<ng-container *ngTemplateOutlet="body" />
}

<ng-template #body>
	@if (!isModalMode) {
		<div class="flex-v-center flex-grow-1 section-title">
			<ng-container *ngTemplateOutlet="head" />
		</div>
	}
	<div class="reports-container">
		@if (showVis) {
			<div class="showVis">
				<label style="margin-inline-start: 10px">{{
					"select_report_fields" | langVal
				}}</label>
				<div class="vis-field">
					@for (field of reportVisFields[report_name]; track field) {
						<div>
							<input
								[checked]="visFields[field]"
								(change)="
									visFields[field] = $event.target.checked; updateVisFields()
								"
								type="checkbox"
							/>
							<span
								(click)="
									visFields[field] = !visFields[field]; updateVisFields()
								"
							>
								@if (report_name == "followups_text_report") {
									@switch (field) {
										@case ("description") {
											{{ "medical_record" | langVal }}
										}
										@case ("remarks") {
											{{ "personal_memorandum" | langVal }}
										}
										@default {
											{{ field | langVal }}
										}
									}
								} @else {
									{{ field | langVal }}
								}
							</span>
						</div>
					}
				</div>
			</div>
		}

		<!--  <label style="margin-inline-start: 10px;">{{'personalize' | langVal}}</label>-->

		<div class="d-flex flex-column mb-3">
			<div class="d-flex justify-content-between">
				<div class="d-grid flex-grow-1 gap-3">
					@if (
						report_name != "real_debt_report" && report_name != "debts_report2"
					) {
						<div class="colstat">
							<label>{{ "period" | langVal }}</label>
							<app-gen-button-group
								[actualObj]="reportParamsObj"
								fieldName="report_period_input"
								[options]="periodInputs"
								title_ph_lang="period"
								(changeEvent)="
									changeBtn(
										'report_period_input',
										reportParamsObj.report_period_input
									)
								"
							/>
						</div>

						@if (dates_range) {
							<div class="d-flex">
								<div class="colstat colstat-small">
									<label>{{ "from_date" | langVal }}</label>
									<app-date-picker
										#fromDate
										[actualObj]="reportParamsObj"
										[errors]="errors"
										fieldName="from_date"
										(changeEvent)="onDateChange('from_date')"
										[addonObject]="{ after: { icon: 'calendar' } }"
									>
									</app-date-picker>
								</div>
								<div class="colstat-small">
									<label>{{ "to_date" | langVal }}</label>
									<app-date-picker
										#toDate
										[actualObj]="reportParamsObj"
										[errors]="errors"
										fieldName="to_date"
										(changeEvent)="onDateChange('to_date')"
										[addonObject]="{ after: { icon: 'calendar' } }"
									>
									</app-date-picker>
								</div>

								@if (report_name == "debts_report") {
									<div style="padding: 0px 15px 5px 15px">
										<input
											type="checkbox"
											[(ngModel)]="reportParamsObj.calcIncomeAsNextMonth"
											[checked]="reportParamsObj.calcIncomeAsNextMonth"
											(change)="getTableRows()"
										/>
										<label>{{ "calc_income_as_next_month" | langVal }}</label>
									</div>
								}
							</div>
						}
					}
					<div class="d-flex flex-column flex-sm-row">
						@if (hasFuzzyFields) {
							<div class="d-flex">
								<div>
									<label>{{ "filter" | langVal }}</label>
									<div class="d-flex flex-nowrap">
										@for (field of fuzzyFields; track field) {
											<div class="colstat">
												<app-gen-autocomplete
													[fuzzySearchableClasses]="field.collection"
													[title_ph_lang]="field.lang"
													[searchStr]="
														filterFieldName == field.fieldName
															? filterFieldShown
															: ''
													"
													[disabled]="filterFieldName == field.fieldName"
													(chosenEvent)="onAcChoose(field.fieldName, $event)"
												/>
											</div>
										}
									</div>
								</div>
								@if (
									permsService.owner_has_users &&
									(report_name
										| inArray
											: [
													"followups_text_report",
													"followups_sub_user_report",
													"followups_sub_user_rent_report",
													"patients_sub_user_report",
											  ])
								) {
									<div>
										<label>{{ "filter_locations" | langVal }}</label>
										<div class="colstat">
											<app-autocomplete-with-tags
												(chosenEvent)="chooseTags($event, false)"
												title_ph_lang="filter_locations"
											/>
										</div>
									</div>
								}
							</div>
						}
						@if (
							report_name != "real_debt_report" &&
							report_name != "debts_report2"
						) {
							@if (report_name != "debts_report") {
								<div>
									<label>{{ "break" | langVal }}</label>

									<app-gen-button-group
										[actualObj]="reportParamsObj"
										fieldName="report_break_input"
										[options]="breakInputsMV()"
										title_ph_lang="break"
										(changeEvent)="
											changeBtn(
												'report_break_input',
												reportParamsObj.report_break_input
											)
										"
									/>
								</div>
							}
						}
					</div>
				</div>
				<div class="d-flex flex-column gap-2 report-settings pad-btns">
					@if (
						report_name == "invoices_report" ||
						report_name == "invoices_report_by_payment_method"
					) {
						<app-gen-button-group
							[actualObj]="reportParamsObj"
							fieldName="invoices_report_by_opts"
							optionsListName="invoices_report_by_opts"
							title_ph_lang="invoices_report_by_opts"
							(changeEvent)="
								changeReport(reportParamsObj.invoices_report_by_opts)
							"
						/>
					}

					@if (
						report_name == "debts_report" || report_name == "real_debt_report"
					) {
						<app-gen-button-group
							[actualObj]="reportParamsObj"
							fieldName="debts_report_opts"
							optionsListName="debts_report_opts"
							title_ph_lang="debts_report"
							(changeEvent)="changeReport(reportParamsObj.debts_report_opts)"
						/>
					}
					@if (
						report_name == "invoices_report" ||
						report_name == "invoices_report_by_payment_method"
					) {
						<app-gen-button-group
							[actualObj]="reportParamsObj"
							fieldName="showItemNumberAsName"
							optionsListName="show_numbers_not_names_opts"
							title_ph_lang="show_numbers_not_names"
							(changeEvent)="
								changeBtn(
									'showItemNumberAsName',
									reportParamsObj.showItemNumberAsName
								)
							"
						/>
					}
					@if (
						is_new_vat_number &&
						(report_name
							| inArray
								: [
										"invoices_report",
										"followups_report",
										"followups_text_report",
										"followups_all_report",
										"proformas_report",
										"justinvoices_report",
										"debts_report",
										"invoices_report_by_payment_method",
								  ])
					) {
						<app-gen-select
							[actualObj]="reportParamsObj"
							fieldName="vat_number"
							[options]="vat_numbers"
							(changeEvent)="
								changeBtn('vat_number', reportParamsObj.vat_number)
							"
						/>
					}
					@switch (report_name) {
						@case ("debts_report2") {
							<div class="d-flex gap-3 mis-auto justify-content-end">
								<button
									class="btn btn-primary"
									(click)="modalProps = { name: 'debt-patients' }"
								>
									{{ "patients_in_balance" | langVal }}
								</button>
								<app-gen-button-group
									[actualObj]="reportParamsObj"
									fieldName="active"
									optionsListName="active_all_opts"
									title_ph_lang="select_active_no_all"
									(changeEvent)="changeBtn('active', reportParamsObj.active)"
								/>
								<app-gen-button-group
									[actualObj]="reportParamsObj"
									fieldName="until_now"
									optionsListName="until_now_opts"
									title_ph_lang="until_now"
									(changeEvent)="
										changeBtn('until_now', reportParamsObj.until_now)
									"
								/>
							</div>
						}
						@case ("debts_report") {
							@if (cliniqData.invoice_per_followup == "yes") {
								<div class="col-12 col-xl-6">
									<app-gen-button-group
										[actualObj]="reportParamsObj"
										fieldName="showOnlyFollowups"
										optionsListName="showOnlyFollowups_opts"
										title_ph_lang="show_only_followups"
										(changeEvent)="
											changeBtn(
												'showOnlyFollowups',
												reportParamsObj.showOnlyFollowups
											)
										"
									/>
								</div>
							}
						}
						@case ("expenses_report") {
							<div>
								<label>{{ "show_expenses" | langVal }}</label>
								<app-gen-button-group
									[actualObj]="reportParamsObj"
									fieldName="showByCreatedAt"
									optionsListName="showByCreatedAt_opts"
									title_ph_lang="show_by_created_at"
									(changeEvent)="
										changeBtn(
											'showByCreatedAt',
											reportParamsObj.showByCreatedAt
										)
									"
								/>
							</div>
						}
						@case ("followups_sub_user_rent_report") {
							<div class="col-12 col-md-10">
								<app-gen-button-group
									isArray
									title_ph_lang="patient_view"
									[actualObj]="reportParamsObj"
									fieldName="individualView"
									[options]="individualViews"
									(changeEvent)="changeBtn('individualView', $event)"
								/>
							</div>
						}
						@case ("justinvoices_report") {
							<div>
								<app-gen-button-group
									isArray
									title_ph_lang="is_paid"
									[actualObj]="reportParamsObj"
									fieldName="paidByInvoiceMode"
									[options]="paidByInvoiceModes"
									(changeEvent)="changeBtn('paidByInvoiceMode', $event)"
								/>
							</div>
						}
					}
				</div>
			</div>
		</div>

		<div id="period-range">
			<h3>
				<span>
					{{ report_lang | langVal }}
					@if (report_name == "expenses_report") {
						@if (reportParamsObj.showByCreatedAt == "yes") {
							{{ "by_created_at" | langVal }}
						} @else {
							{{ "by_expense_date" | langVal }}
						}
					}
				</span>

				@if (dates_range && report_name != "debts_report2") {
					<span>{{ reportParamsObj.from_date | dateFormat }}</span> -
					<span>{{ reportParamsObj.to_date | dateFormat }}</span>
					@if (filterFieldShown) {
						<span> - {{ filterFieldShown }}</span>
					}
				}

				@if (
					permsService.owner_has_users &&
					permsService?.perms?.clinical &&
					!permsService?.perms?.administrative
				) {
					<div>{{ cliniqData?.sub_user_name }}</div>
				}
			</h3>
		</div>

		@if (itemName) {
			<div class="h5">
				<h3>{{ itemName }}</h3>
			</div>
		}

		<app-spin-or-content [isSpin]="isLoading">
			<div id="section-to-print">
				<div>
					<div class="table-responsive">
						<table class="table table-hover table-rows">
							<thead>
								<tr>
									@for (field of fields; track field) {
										<!-- Shows row IF
                  field is not entireRow AND
                  EITHER I'm not conditional at all (undefined)
                  OR my conditional value(true/false) is identical to the value of areConditionalColumnsVisible (which changes by "payment_method") -->
										@if (
											!field.entireRow &&
											(field.conditionalValue === undefined ||
												field.conditionalValue ===
													areConditionalColumnsVisible) &&
											(!visFields || visFields[field.fieldName] !== false)
										) {
											<th
												[class.print_hidden]="
													field.actionType &&
													!(
														$safeNavigationMigration(field?.actionType)
														| inArray: ['downloadInvoice', 'isCheckmark']
													)
												"
												[style.width]="field.width"
												(click)="sort(field)"
												sorter
												[displayName]="
													($index && field.lang ? (field.lang | langVal) : '') +
													' ' +
													(field?.to_date
														? (reportParamsObj.to_date | dateFormat)
														: '')
												"
												[isSortable]="
													field.fieldName &&
													!field.actionType &&
													(reportParamsObj.report_break_input != 'item' ||
														field.fieldName != 'item_name')
												"
												[fieldName]="field.fieldName"
												[sortField]="sortField"
												[sortIsAsc]="sortIsAsc"
											></th>
										}
									}
								</tr>
							</thead>
							<tbody>
								@if (tableRows.length && !hasBreakHeaders) {
									<tr class="totals-row">
										@for (field of fields; track field) {
											@if (
												!field.entireRow &&
												(field.conditionalValue === undefined ||
													field.conditionalValue ===
														areConditionalColumnsVisible) &&
												(!visFields || visFields[field.fieldName] !== false)
											) {
												<td
													[class.print_hidden]="
														field.actionType &&
														!(
															$safeNavigationMigration(field?.actionType)
															| inArray: ['downloadInvoice', 'isCheckmark']
														)
													"
													[style.width]="field.width"
												>
													@if ($index) {
														@if (field.totals) {
															{{ totals[field.fieldName] }}
														}
													} @else {
														{{ "total" | langVal }}
													}
												</td>
											}
										}
									</tr>
								}
								@for (row of tableRows; track row) {
									@if (row.isBreakHeader) {
										<tr class="totals-row">
											<td colspan="99999999">{{ row.name }}</td>
										</tr>
									} @else {
										@if (
											row.isSubTotal ||
											!summarizedView ||
											(curShowToken && curShowToken == row?.showToken)
										) {
											<tr
												[class.totals-row]="row.isSubTotal"
												(click)="rowClick(row)"
											>
												@for (field of fields; track field) {
													@if (
														!field.entireRow &&
														(field.conditionalValue === undefined ||
															field.conditionalValue ===
																areConditionalColumnsVisible) &&
														(!visFields || visFields[field.fieldName] !== false)
													) {
														@if (field.actionType) {
															@switch (field.actionType) {
																@case ("delete") {
																	<td
																		[style.width]="field.width"
																		class="valign-mid"
																	>
																		<app-spin-or-content
																			[isSpin]="
																				$safeNavigationMigration(
																					row?.isDeleting
																				)
																			"
																		>
																			@if (!row?.is_documented) {
																				<button
																					class="btn btn-icon print_hidden"
																					[title]="
																						('delete' | langVal) + ' ' + row.id
																					"
																					(click)="delete(row)"
																					preIcon="delete"
																				>
																					{{ row.id }}
																				</button>
																			}
																		</app-spin-or-content>
																		<span class="print-show">{{ row.id }}</span>
																	</td>
																}
																@case ("downloadInvoice") {
																	<td
																		[style.width]="field.width"
																		class="valign-mid"
																	>
																		<app-spin-or-content
																			[isSpin]="
																				$safeNavigationMigration(
																					row?.downloadSpin
																				)
																			"
																		>
																			@if (
																				row.id &&
																				((row.type
																					| inArray
																						: [
																								"invoice",
																								"justinvoice",
																								"receipt",
																								"proforma",
																						  ]) ||
																					(report_lang
																						| inArray
																							: [
																									"income_report",
																									"income_report_by_payment_method",
																									"admin_income_report",
																							  ]))
																			) {
																				<button
																					class="btn btn-icon print_hidden"
																					[title]="
																						('download' | langVal) +
																						' ' +
																						row.id
																					"
																					(click)="downloadInvoice(row)"
																					preIcon="download"
																				>
																					{{ row.id }}
																				</button>
																			}
																		</app-spin-or-content>
																		<span class="print-show">{{ row.id }}</span>
																	</td>
																}
																@case ("emailInvoice") {
																	<td
																		class="print_hidden"
																		[style.width]="field.width"
																	>
																		@if (
																			row.id &&
																			((row.type
																				| inArray
																					: [
																							"invoice",
																							"justinvoice",
																							"receipt",
																							"proforma",
																					  ]) ||
																				(report_lang
																					| inArray
																						: [
																								"income_report",
																								"income_report_by_payment_method",
																								"admin_income_report",
																						  ]))
																		) {
																			<button
																				class="btn btn-icon"
																				[title]="
																					('email' | langVal) + ' ' + row.id
																				"
																				(click)="openContactwaysModal(row)"
																				icon="email"
																			></button>
																		}
																	</td>
																}
																@case ("creditInvoice") {
																	<td
																		class="print_hidden"
																		[style.width]="field.width"
																	>
																		@if (
																			row.id &&
																			report_lang == "admin_income_report"
																		) {
																			<button
																				class="btn btn-icon"
																				(click)="openCreditModal(row)"
																				[title]="
																					('credit' | langVal) + ' ' + row.id
																				"
																				icon="credit"
																			></button>
																		}
																	</td>
																}
																@case ("emailProforma") {
																	@if (row.isSubTotal) {
																		<td
																			class="print_hidden"
																			[style.width]="field.width"
																		>
																			<button
																				class="btn btn-icon"
																				(click)="
																					addProforma(row);
																					$event.stopImmediatePropagation()
																				"
																				titleLang="proforma"
																				icon="email"
																			></button>
																		</td>
																	}
																}
																@case ("addInvoice") {
																	@if (row.isSubTotal) {
																		<td
																			class="print_hidden"
																			[style.width]="field.width"
																		>
																			<button
																				class="btn btn-icon"
																				(click)="
																					addInvoice(row);
																					$event.stopImmediatePropagation()
																				"
																				titleLang="invoice"
																				icon="invoice"
																			></button>
																		</td>
																	}
																}
																@case ("sendProforma") {
																	@if (row.isSubTotal) {
																		<td
																			class="print_hidden"
																			[style.width]="field.width"
																		>
																			<app-btn-ext
																				title="send_sms_proforma"
																				iconName="sms_small"
																				[isSpin]="
																					$safeNavigationMigration(
																						row?.sendProformaSpin
																					)
																				"
																				(clickEv)="sendProforma(row)"
																				btnClass="icon"
																			/>
																		</td>
																	}
																}
																@case ("sendStatus") {
																	<td
																		class="print_hidden"
																		[style.width]="field.width"
																	>
																		<span
																			[title]="
																				('sendgrid_status' | langVal) +
																				':' +
																				(row.sendgrid_status | langVal)
																			"
																			[icon]="row.sendgrid_status"
																		></span>
																	</td>
																}
																@case ("isCheckmark") {
																	<td [style.width]="field.width">
																		@if (row[field.fieldName] == "yes") {
																			<span>✔</span>
																		}
																	</td>
																}
															}
														} @else {
															<td
																[title]="
																	(field.lang | langVal) +
																	' ' +
																	(row[field.fieldName] || '')
																"
																[style.width]="field.width"
															>
																@if (
																	report_name === "followups_all_report" &&
																	row.status === "deleted"
																) {
																	@switch (field.fieldName) {
																		@case ("item_name") {
																			<span
																				style="text-decoration: line-through"
																				>{{ row[field.fieldName] }}</span
																			>
																		}
																		@case ("followuptype_name") {
																			{{ row.deleted_remarks }}
																		}
																		@default {
																			{{ row[field.fieldName] }}
																		}
																	}
																} @else {
																	@if (field.fieldName == "model_name") {
																		{{ row.model_name | langVal }}
																	} @else {
																		@if (row.isSubTotal && !$index) {
																			<app-icon
																				[icon]="
																					summarizedView &&
																					curShowToken != row?.showToken
																						? 'expand'
																						: 'narrow'
																				"
																				[titleLang]="
																					summarizedView &&
																					curShowToken != row?.showToken
																						? 'expand'
																						: 'narrow'
																				"
																			/>
																			{{
																				(report_name == "debts_report2"
																					? "total_debt"
																					: "total"
																				) | langVal
																			}}
																			{{ row.name }}
																		} @else {
																			{{ row[field.fieldName] }}
																		}
																		<!-- this is the default case -->
																	}
																}
															</td>
														}
													}
												}
											</tr>
										}
									}
									@for (field of fields; track field) {
										@if (
											field.entireRow &&
											row[field.fieldName] &&
											(!visFields || visFields[field.fieldName] !== false)
										) {
											<tr>
												<td
													colspan="999"
													[innerHTML]="row[field.fieldName] | safeHtml"
												></td>
											</tr>
										}
									}
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</app-spin-or-content>
		<div class="modal-btns d-flex justify-content-between align-items-center">
			<button
				class="btn btn-icon print_hidden"
				titleLang="expand"
				[icon]="summarizedView ? 'report_expand' : 'report_narrow'"
				(click)="summarizedView = !summarizedView; curShowToken = null"
			></button>
			<div>
				<app-btn-ext
					text="print"
					(clickEv)="print()"
				/>
				<app-btn-ext
					text="create_excel"
					(clickEv)="downloadReport()"
				/>

				@if (
					itemFuzzy && reportParamsObj?.item_type === "patient" && "patients"
						| inArray: itemFuzzy.collection
				) {
					<app-btn-ext
						text="letter_export"
						(clickEv)="addDocument()"
					/>
				}
				@if (
					report_name == "debts_report" &&
					reportParamsObj.item_id &&
					reportParamsObj.item_type == "patient"
				) {
					<app-btn-ext
						text="email_report_to_patient"
						(clickEv)="modalProps = { name: 'table-display-contactways-email' }"
						[isSpin]="isSendingPdf"
					/>
				}
				@if (isModalMode) {
					<app-btn-ext
						text="close_btn"
						(clickEv)="onClose.emit()"
						btnClass="default"
					/>
				}
			</div>
		</div>
	</div>
</ng-template>
<ng-template #head>
	<h4 class="gen-title">
		{{ report_lang | langVal }}
		@if (report_name == "expenses_report") {
			{{
				(reportParamsObj.showByCreatedAt == "yes"
					? "by_created_at"
					: "by_expense_date"
				) | langVal
			}}
		}

		@if (dates_range && report_name != "debts_report2") {
			<span class="no-small-mob">
				<span>{{ reportParamsObj.from_date | dateFormat }}</span> -
				<span>{{ reportParamsObj.to_date | dateFormat }}</span>
				@if (filterFieldShown) {
					<span> - {{ filterFieldShown }}</span>
				}
			</span>
		}

		@if (
			permsService.owner_has_users &&
			permsService?.perms?.clinical &&
			!permsService?.perms?.administrative
		) {
			<div>{{ cliniqData?.sub_user_name }}</div>
		}
	</h4>

	<div class="text-end">
		<button
			class="btn btn-icon print_hidden"
			titleLang="report_defs"
			[icon]="'settings1'"
			style="min-height: 20px"
			(click)="showVis = !showVis"
		></button>
	</div>
</ng-template>

@switch (modalProps?.name) {
	@case ("add-invoice") {
		<app-add-invoice
			(onClose)="modalProps = null"
			[description]="modalProps.description"
			[doctype]="modalProps.doctype"
			[paid_by]="$safeNavigationMigration(modalProps.row?.name)"
			[is_withholding_tax]="
				$safeNavigationMigration(modalProps.row?.item_type.is_withholding_tax)
			"
			[withholding_tax_percent]="
				$safeNavigationMigration(
					modalProps.row?.item_type.withholding_tax_percent
				)
			"
			[for]="$safeNavigationMigration(modalProps.row?.name)"
			[resource]="$safeNavigationMigration(modalProps.row?.item_type)"
			[resourceId]="$safeNavigationMigration(modalProps.row?.item_id)"
		/>
	}
	@case ("debt-patients") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-narrow-width"
		>
			<app-debt-patients (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("finresource-credit") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="credit_invoice"
			modalWrapperClass="modal-650"
		>
			<app-finresource-credit
				(onClose)="modalProps = null"
				[objectRow]="modalProps.objectRow"
			/>
		</app-modal-wrap>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null"
				[patient_id]="modalProps.patient_id"
				[title]="modalProps.title"
				[preText]="modalProps.preText"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways-email") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="
					modalProps = null;
					$event?.length && handleContactwaysEmailClose($event)
				"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="reportParamsObj.item_id"
				fieldNameInItemToDisplay="contactway"
				isCheckItems
				[filterFieldApiObject]="{ contactway_identifier: 'email' }"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways-download-invoice") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="
					modalProps = null;
					$event?.length && handleContactwaysDownloadInvoiceClose($event)
				"
				tableName="contactways"
				[filterField]="curRow.item_type + '_id'"
				[filterFieldValue]="curRow.item_id"
				fieldNameInItemToDisplay="contactway"
				isCheckItems
				[filterFieldApiObject]="modalProps.filterFieldApiObject"
				[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
			/>
		</app-modal-wrap>
	}
}
@if (sendProformaProps) {
	<app-send-proforma
		[patient]="sendProformaProps.patient"
		(onDone)="
			sendProformaProps.row.sendProformaSpin = false; sendProformaProps = null
		"
	/>
}
